import { gsap } from "gsap";

export const buttonStyles = (isExpanded: boolean, theme: string) => `
  fixed z-[9999] text-sm font-bold px-4 py-2 rounded-full cursor-pointer hidden
  ${isExpanded ? "" : "hover:bg-opacity-90"}
  mobile:top-0 mobile:left-1/2 mobile:transform mobile:-translate-x-1/2 mobile:w-full mobile:rounded-none
  tablet:top-0 tablet:left-1/2 tablet:transform tablet:-translate-x-1/2 tablet:w-full tablet:rounded-none
  laptop:top-8 laptop:left-1/2 laptop:transform laptop:-translate-x-1/2 laptop:w-[230px]
  desktop:top-8 desktop:left-1/2 desktop:transform desktop:-translate-x-1/2 desktop:w-[230px]
`;

export const animateButton = (
  betaButtonRef: React.RefObject<HTMLDivElement>,
  theme: string,
) => {
  if (betaButtonRef.current) {
    gsap.to(betaButtonRef.current, {
      backgroundColor: theme === "light" ? "#000000" : "#ffffff",
      duration: 0.3,
      ease: "power2.out",
    });
  }
};

export const animateText = (
  betaTextRef: React.RefObject<HTMLSpanElement>,
  theme: string,
  setTextColor: (color: string) => void,
) => {
  gsap.to(betaTextRef.current, {
    color: theme === "light" ? "#ffffff" : "#000000",
    duration: 0.3,
    ease: "power2.out",
    onUpdate: () => {
      if (betaTextRef.current) {
        setTextColor(getComputedStyle(betaTextRef.current).color);
      }
    },
  });
};

export const createConfetti = (
  x: number,
  y: number,
  isBurst: boolean,
  confettiRef: React.RefObject<HTMLDivElement>,
) => {
  const confettiCount = isBurst ? 50 : 1;
  const confettiElements: HTMLDivElement[] = [];

  for (let i = 0; i < confettiCount; i++) {
    const confetti = document.createElement("div");
    confetti.className = "absolute w-2 h-1";
    confetti.style.left = `${x}px`;
    confetti.style.top = `${y}px`;
    confetti.style.backgroundColor = getRandomColor();
    confettiRef.current?.appendChild(confetti);
    confettiElements.push(confetti);
  }

  gsap.to(confettiElements, {
    x: () => gsap.utils.random(-300, 300),
    y: () => gsap.utils.random(-300, 300),
    rotation: gsap.utils.random(-180, 180),
    opacity: 0,
    duration: isBurst ? 4 : 2,
    ease: "power2.out",
    stagger: isBurst ? 0.02 : 0,
    onComplete: () => {
      confettiElements.forEach((el) => confettiRef.current?.removeChild(el));
    },
  });
};

export const getRandomColor = () => {
  const colors = [
    "#3099ff",
    "#f1f1f4",
    "#050719",
    "#525566",
    "#FF69B4",
    "#39FF14",
    "#00FFFF",
    "#FF1493",
    "#7CFC00",
    "#1E90FF",
  ];
  return colors[Math.floor(Math.random() * colors.length)];
};
